import {
    ActionsPanel_SingleFileTooLarge,
    ActionsPanel_MultipleFilesTooLarge,
    ActionsPanel_SingleFileSuggestSharing,
    ActionsPanel_MultipleFilesSuggestSharing,
    ActionsPanel_AttachFluid,
    ActionsPanel_AttachFolder,
    ActionsPanel_AttachWithoutExtension,
    ActionsPanel_AttachOneNote,
    ActionsPanel_AttachGoogleFiles,
    ActionsPanel_SharePlainText,
    ActionsPanel_SharePermissions,
    ActionsPanel_AttachSharedCalendar,
    ActionsPanel_UploadToConsumerGroup,
    ActionsPanel_AttachGroupCalendar,
    ActionsPanel_ShareEncryptedMessage,
} from './FilePickerActionMessageType.locstring.json';
import loc from 'owa-localize';

const enum FilePickerActionMessageType {
    SingleFileTooLarge,
    MultipleFilesTooLarge,
    SingleFileSuggestSharing,
    MultipleFilesSuggestSharing,
    AttachFolder,
    AttachFluid,
    AttachWithoutExtension,
    AttachOneNote,
    AttachGoogleFiles,
    SharePlainText,
    SharePermissions,
    AttachSharedCalendar,
    UploadToConsumerGroup,
    AttachGroupCalendar,
    ShareEncryptedMessage,
}

export default FilePickerActionMessageType;

export const actionMessageMap: { [filePickerActionMessageType: number]: () => string } = {
    [FilePickerActionMessageType.SingleFileTooLarge]: () => loc(ActionsPanel_SingleFileTooLarge),
    [FilePickerActionMessageType.MultipleFilesTooLarge]: () =>
        loc(ActionsPanel_MultipleFilesTooLarge),
    [FilePickerActionMessageType.SingleFileSuggestSharing]: () =>
        loc(ActionsPanel_SingleFileSuggestSharing),
    [FilePickerActionMessageType.MultipleFilesSuggestSharing]: () =>
        loc(ActionsPanel_MultipleFilesSuggestSharing),
    [FilePickerActionMessageType.AttachFluid]: () => loc(ActionsPanel_AttachFluid),
    [FilePickerActionMessageType.AttachFolder]: () => loc(ActionsPanel_AttachFolder),
    [FilePickerActionMessageType.AttachWithoutExtension]: () =>
        loc(ActionsPanel_AttachWithoutExtension),
    [FilePickerActionMessageType.AttachOneNote]: () => loc(ActionsPanel_AttachOneNote),
    [FilePickerActionMessageType.AttachGoogleFiles]: () => loc(ActionsPanel_AttachGoogleFiles),
    [FilePickerActionMessageType.SharePlainText]: () => loc(ActionsPanel_SharePlainText),
    [FilePickerActionMessageType.ShareEncryptedMessage]: () =>
        loc(ActionsPanel_ShareEncryptedMessage),
    [FilePickerActionMessageType.SharePermissions]: () => loc(ActionsPanel_SharePermissions),
    [FilePickerActionMessageType.AttachSharedCalendar]: () =>
        loc(ActionsPanel_AttachSharedCalendar),
    [FilePickerActionMessageType.UploadToConsumerGroup]: () =>
        loc(ActionsPanel_UploadToConsumerGroup),
    [FilePickerActionMessageType.AttachGroupCalendar]: () => loc(ActionsPanel_AttachGroupCalendar),
};
